export class Account {
    static readonly type = `[AccountState] store credentials`;
    constructor(public payload) { }
}